"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivityByTime = exports.getIsSpeaker = exports.getIsSinger = exports.getIsStuntPerformer = exports.getIsPilot = exports.getIsDancer = exports.getIsAFMPerformer = exports.getIsExtra = exports.getIsPrincipal = exports.getIsOffCameraGroup = exports.getIsOffScreenPrincipal = exports.getIsOnCameraGroup = exports.getIsOnScreenPrincipal = exports.getIsHolidayWorkTime = exports.getIsSundayWorkTime = exports.getIsSaturdayWorkTime = exports.getIsLateNightWorkTime = exports.getIsNightWorkTime = exports.getIsAFMRecordingSession = exports.getIsRecordingSession = exports.getIsFitting = exports.getIsWardrobeChange = exports.getIsMeal = exports.getIsTravelFromAfterMidnight = exports.getIsTravelFrom = exports.getIsTravelToAfterMidnight = exports.getIsTravelTo = exports.getIsTravel = exports.getIsWork = void 0;
const types_1 = require("@shared/types");
/**
 * Activity Types
 */
const getIsWork = (activityType) => types_1.WorkActivityTypes.has(activityType);
exports.getIsWork = getIsWork;
const getIsTravel = (activityType) => types_1.TravelActivityTypes.has(activityType);
exports.getIsTravel = getIsTravel;
const getIsTravelTo = (activityType) => activityType === types_1.SessionActivityType.TravelToLocation;
exports.getIsTravelTo = getIsTravelTo;
const getIsTravelToAfterMidnight = (activityType) => activityType === types_1.SessionActivityType.TravelToLocationAfterMidnight;
exports.getIsTravelToAfterMidnight = getIsTravelToAfterMidnight;
const getIsTravelFrom = (activityType) => activityType === types_1.SessionActivityType.TravelFromLocation;
exports.getIsTravelFrom = getIsTravelFrom;
const getIsTravelFromAfterMidnight = (activityType) => activityType === types_1.SessionActivityType.TravelFromLocationAfterMidnight;
exports.getIsTravelFromAfterMidnight = getIsTravelFromAfterMidnight;
const getIsMeal = (activityType) => types_1.MealActivityTypes.has(activityType);
exports.getIsMeal = getIsMeal;
const getIsWardrobeChange = (activityType) => activityType === types_1.SessionActivityType.WardrobeChange;
exports.getIsWardrobeChange = getIsWardrobeChange;
const getIsFitting = (activityType) => activityType === types_1.SessionActivityType.Fitting;
exports.getIsFitting = getIsFitting;
const getIsRecordingSession = (activityType) => activityType === types_1.SessionActivityType.VoiceOver ||
    activityType === types_1.SessionActivityType.RecordingSession;
exports.getIsRecordingSession = getIsRecordingSession;
const getIsAFMRecordingSession = (activityType) => activityType === types_1.SessionActivityType.AFMRecordingSession;
exports.getIsAFMRecordingSession = getIsAFMRecordingSession;
/**
 * Work Time Types
 */
const getIsNightWorkTime = (activityType) => activityType === types_1.SessionActivityType.WorkTimeNight;
exports.getIsNightWorkTime = getIsNightWorkTime;
const getIsLateNightWorkTime = (activityType) => activityType === types_1.SessionActivityType.WorkTimeLateNight;
exports.getIsLateNightWorkTime = getIsLateNightWorkTime;
const getIsSaturdayWorkTime = (activityType) => activityType === types_1.SessionActivityType.WorkTimeSaturday;
exports.getIsSaturdayWorkTime = getIsSaturdayWorkTime;
const getIsSundayWorkTime = (activityType) => activityType === types_1.SessionActivityType.WorkTimeSunday;
exports.getIsSundayWorkTime = getIsSundayWorkTime;
const getIsHolidayWorkTime = (activityType) => activityType === types_1.SessionActivityType.WorkTimeHoliday;
exports.getIsHolidayWorkTime = getIsHolidayWorkTime;
/**
 * Role Types
 */
const getIsOnScreenPrincipal = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.OnCameraPrincipal;
exports.getIsOnScreenPrincipal = getIsOnScreenPrincipal;
const getIsOnCameraGroup = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.OnCameraGroup;
exports.getIsOnCameraGroup = getIsOnCameraGroup;
const getIsOffScreenPrincipal = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.OffCameraPrincipal;
exports.getIsOffScreenPrincipal = getIsOffScreenPrincipal;
const getIsOffCameraGroup = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.OffCameraGroup;
exports.getIsOffCameraGroup = getIsOffCameraGroup;
const getIsPrincipal = (rolePerformerType) => (0, exports.getIsOnScreenPrincipal)(rolePerformerType) ||
    (0, exports.getIsOffScreenPrincipal)(rolePerformerType);
exports.getIsPrincipal = getIsPrincipal;
const getIsExtra = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.Extra;
exports.getIsExtra = getIsExtra;
const getIsAFMPerformer = (rolePerformerType) => rolePerformerType === types_1.RolePerformerType.AFM;
exports.getIsAFMPerformer = getIsAFMPerformer;
const getIsDancer = (roleType) => roleType === types_1.RoleType.SpecialtyDancer;
exports.getIsDancer = getIsDancer;
const getIsPilot = (roleType) => roleType === types_1.RoleType.Pilot;
exports.getIsPilot = getIsPilot;
const getIsStuntPerformer = (roleType) => roleType === types_1.RoleType.StuntPerformer;
exports.getIsStuntPerformer = getIsStuntPerformer;
const getIsSinger = (roleType) => roleType === types_1.RoleType.Singer;
exports.getIsSinger = getIsSinger;
const getIsSpeaker = (roleType) => roleType === (types_1.RoleType.Narrator || types_1.RoleType.Announcer || types_1.RoleType.Speaker);
exports.getIsSpeaker = getIsSpeaker;
/**
 * Looks up Session Activity by time.
 * @param sessionActivities
 * @param timePointer
 * @returns SessionActivity
 */
const getActivityByTime = (sessionActivities, timePointer) => {
    return sessionActivities[sessionActivities.findIndex((sessionActivity) => {
        // Equivalent to moment's `.isBetween(start, end, undefined, '[)')` - start-inclusive,
        // end-exclusive. dayjs has no isBetween of its own; matches apps/web/src/utils/time.ts's
        // existing hand-rolled convention for this rather than adding a dayjs plugin.
        const start = timePointer.isSame(sessionActivity.start_time) || timePointer.isAfter(sessionActivity.start_time);
        const end = timePointer.isBefore(sessionActivity.end_time);
        return start && end;
    })];
};
exports.getActivityByTime = getActivityByTime;
//# sourceMappingURL=session-helpers.js.map